import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  ADD_GCP_ACCOUNT,
  ADD_GCP_ACCOUNT_SUCCESS,
  ADD_GCP_ACCOUNT_ERROR,
} from "./gcpActions";

const initialState = {
  phase: INIT,
  error: null,
  accountAdded: null,
};

export function AddGCPAccountStore(state = initialState, action) {
  switch (action.type) {
    case ADD_GCP_ACCOUNT:
      return {
        ...state,
        phase: LOADING,
      };
    case ADD_GCP_ACCOUNT_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        accountAdded: action.data,
        error: null,
      };
    case ADD_GCP_ACCOUNT_ERROR:
      return { ...state, phase: ERROR, error: action.error };
    default:
      return state;
  }
}
